/* eslint-disable react/jsx-no-target-blank */
import {AsideMenuItem} from './AsideMenuItem'

type Props = {
  onLinkClick?: () => void
}

export function AsideMenuMain({onLinkClick}: Props) {
  return (
    <>
      <AsideMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/art/art002.svg'
        title='Dashboard'
        fontIcon='bi-layers'
        onClick={onLinkClick}
      />
      <AsideMenuItem
        to='/blogs'
        icon='/media/icons/duotune/art/art002.svg'
        title='Blogs'
        fontIcon='bi-layers'
        onClick={onLinkClick}
      />
      <AsideMenuItem
        to='/contact-us'
        icon='/media/icons/duotune/art/art002.svg'
        title='Contact Us'
        fontIcon='bi-layers'
        onClick={onLinkClick}
      />
      <AsideMenuItem
        to='/jobs'
        icon='/media/icons/duotune/art/art002.svg'
        title='Jobs'
        fontIcon='bi-briefcase'
        onClick={onLinkClick}
      />
      <AsideMenuItem
        to='/applications'
        icon='/media/icons/duotune/art/art002.svg'
        title='Applications'
        fontIcon='bi-people'
        onClick={onLinkClick}
      />
      {/* <AsideMenuItem
        to='/comment'
        icon='/media/icons/duotune/art/art002.svg'
        title='Comment'
        fontIcon='bi-layers'
        onClick={onLinkClick}
      /> */}
      {/* <AsideMenuItem
        to='/user'
        icon='/media/icons/duotune/communication/com014.svg'
        title='Users'
        fontIcon='bi-layers'
        onClick={onLinkClick}
      /> */}
    </>
  )
}
